export default __webpack_public_path__ + "static/media/vineLeft.5b772331.svg";